(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ils-machine-main"] && !Shopify.designMode) return;
  try {
    
  function initIlsProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const image = root.querySelector('.ilm-main-image');
    const zoom = root.querySelector('.ilm-zoom');
    root.querySelectorAll('[data-ils-image]').forEach(link => {
      link.addEventListener('click', event => {
        if (!image || !zoom) return;
        event.preventDefault();
        image.removeAttribute('srcset');
        image.src = link.dataset.ilsImage;
        image.alt = link.dataset.ilsImageAlt;
        image.dataset.imageId = link.dataset.ilsImageId;
        zoom.href = link.href;
        root.querySelectorAll('[data-ils-image]').forEach(item => item.removeAttribute('aria-current'));
        link.setAttribute('aria-current', 'true');
        root.dispatchEvent(new CustomEvent('ils:gallery-change'));
      });
    });
    const variant = root.querySelector('[data-ils-variant]');
    if (variant) variant.addEventListener('change', () => variant.form.requestSubmit());
  }
  document.querySelectorAll('[data-ils-product]').forEach(initIlsProduct);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ils-product]').forEach(initIlsProduct));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ils-product-star"] && !Shopify.designMode) return;
  try {
    
  function initIlsProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const image = root.querySelector('.ilm-main-image');
    const zoom = root.querySelector('.ilm-zoom');
    root.querySelectorAll('[data-ils-image]').forEach(link => {
      link.addEventListener('click', event => {
        if (!image || !zoom) return;
        event.preventDefault();
        image.removeAttribute('srcset');
        image.src = link.dataset.ilsImage;
        zoom.href = link.href;
        root.querySelectorAll('[data-ils-image]').forEach(item => item.removeAttribute('aria-current'));
        link.setAttribute('aria-current', 'true');
      });
    });
    const variant = root.querySelector('[data-ils-variant]');
    if (variant) variant.addEventListener('change', () => variant.form.requestSubmit());
  }
  document.querySelectorAll('[data-ils-product]').forEach(initIlsProduct);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ils-product]').forEach(initIlsProduct));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ils-product"] && !Shopify.designMode) return;
  try {
    
  function initIlsProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const image = root.querySelector('.ilm-main-image');
    const zoom = root.querySelector('.ilm-zoom');
    root.querySelectorAll('[data-ils-image]').forEach(link => {
      link.addEventListener('click', event => {
        if (!image || !zoom) return;
        event.preventDefault();
        image.removeAttribute('srcset');
        image.src = link.dataset.ilsImage;
        zoom.href = link.href;
        root.querySelectorAll('[data-ils-image]').forEach(item => item.removeAttribute('aria-current'));
        link.setAttribute('aria-current', 'true');
      });
    });
    const variant = root.querySelector('[data-ils-variant]');
    if (variant) variant.addEventListener('change', () => variant.form.requestSubmit());
  }
  document.querySelectorAll('[data-ils-product]').forEach(initIlsProduct);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ils-product]').forEach(initIlsProduct));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const variant = root.querySelector('[data-ils-variant]');
      if (variant) variant.addEventListener('change', () => variant.form.requestSubmit());
      const bar = root.querySelector('[data-s-quotebar]');
      const box = root.querySelector('#buy');
      if (bar && box && 'IntersectionObserver' in window) {
        const mq = matchMedia('(max-width: 989px)');
        new IntersectionObserver(([e]) => { bar.hidden = !mq.matches || e.isIntersecting; }).observe(box);
        bar.querySelector('[data-s-quote-proxy]').addEventListener('click', () => {
          const real = root.querySelector('.ils-poa__btn.rfq-btn') || root.querySelector('.ils-poa__btn:not([disabled])');
          if (real) real.click(); else box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    }
    // If the quote app has not hydrated within 6s of load, keep the journey working via the native quote form.
    function quoteFallback(root) {
      const btn = root.querySelector('.ils-poa__btn[data-fallback]');
      if (!btn) return;
      window.addEventListener('load', () => setTimeout(() => {
        if (root.querySelector('.ils-poa__btn.rfq-btn')) return;
        btn.disabled = false;
        btn.addEventListener('click', () => { window.location.href = btn.dataset.fallback; }, { once: true });
      }, 6000), { once: true });
    }
    document.querySelectorAll('[data-ils-product]').forEach((r) => { init(r); quoteFallback(r); });
    document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-ils-product]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();
})();
